import { render } from "./ftaReverseLogistics.vue?vue&type=template&id=8a4a992c&scoped=true"
import script from "./ftaReverseLogistics.vue?vue&type=script&lang=js"
export * from "./ftaReverseLogistics.vue?vue&type=script&lang=js"

import "./ftaReverseLogistics.vue?vue&type=style&index=0&id=8a4a992c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4a992c"]])

export default __exports__